import { useTranslation } from "react-i18next";
import { useFetchLoans } from "../../hooks/fetch-data/useFetchLoans";
import SEO from "../../components/seo/SEO";
import LoanDetail from "./LoanDetail";

const NanoLoanDetailPage = () => {
  const { t } = useTranslation("loanDetail");

  const { data: loans, isFetching: isFetchingLoans } = useFetchLoans();

  const loanInfo = loans?.[2]; // Third product

  return (
    <>
      <SEO
        title={t("nano.title")}
        description={t("nano.description")}
        url={window.location.href}
        imageUrl={`${window.location.origin}/assets/img/ci/icon/icon-aunjai.svg`}
      />
      <LoanDetail loanInfo={loanInfo} isFetchingLoans={isFetchingLoans} />
    </>
  );
};

export default NanoLoanDetailPage;
